import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HomeService {

  constructor(private httpclient: HttpClient) { }

  GetAddMemberInitialModel(member:any) {
    return this.httpclient.post(environment.appUrl + '/api/JoinOnlineSentinel/GetAddMemberInitialModel',member);
  }
  AddCustomer(member:any) {
    return this.httpclient.post(environment.appUrl + '/api/JoinOnlineSentinel/AddCustomer',member);
  }
  GetItemList(member:any) {
    return this.httpclient.post(environment.appUrl + '/api/JoinOnlineSentinel/GetItemList',member);
  }
  AddTransactionItem(member:any) {
    return this.httpclient.post(environment.appUrl + '/api/JoinOnlineSentinel/AddTransactionItem',member);
  }
  AddTransactionPaymentOnline(member:any) {
    return this.httpclient.post(environment.appUrl + '/api/JoinOnlineSentinel/AddTransactionPaymentOnline',member);
  }
  getOnlinePaymentAdyenPayNow(transaction:any) {
    return this.httpclient.post(environment.appUrl + '/api/PaymentGatewayAdyen/OnlinePaymentPayNow', transaction)
  }
  makePaymentAyden(model:any) {
    return this.httpclient.post(environment.appUrl + '/api/PaymentGatewayAdyen/MakePaymentAyden', model)
  }
  GetTerms(model:any) {
    return this.httpclient.post(environment.appUrl + '/api/JoinOnlineSentinel/GetTerms', model)
  }
}
